import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/Download.svg";
import { ReactComponent as GenerateIcon } from "../../Icons/Regenerate.svg";
import { UUIDGenerateAPI } from "../../Services/APIService";



function UUIDGenerator() {
    const [hasSingleCopied, setHasSingleCopied] = useState(false);
    const [hasBulkCopied, setHasBulkCopied] = useState(false);
    const [hasDownloaded, setHasDownloaded] = useState(false);
    const toolFav = { toolName: 'UUID Generator', Iconpath: "/FileCodeRaw.svg" };
    const versions = [
        { name: "Version 1 (Timestamp)", value: "V1" },
        { name: "Version 4 (Random)", value: "V4" },
        { name: "Version 7 (Namespace)", value: "V7" },
    ];

    const [selectedVersion, setSelectedVersion] = useState(
        { name: "Version 1 (Timestamp)", value: "V1" },
    );
    const [bulkVersion, setBulkVersion] = useState(
        { name: "Version 4 (Random)", value: "V4" },
    );
    const [singleUUID, setSingleUUID] = useState([]);
    const [bulkCount, setBulkCount] = useState(0);

    const [bulkUUIDs, setbulkUUIDS] = useState([]);

    const handleCopy = (text, type) => {

        if (type === "single") {
            navigator.clipboard.writeText(text);
            setHasSingleCopied(true);
            setTimeout(() => setHasSingleCopied(false), 2000);
        } else {
            navigator.clipboard.writeText(bulkUUIDs.join("\n"));
            setHasBulkCopied(true);
            setTimeout(() => setHasBulkCopied(false), 2000);
        }
    };

    const handleDownload = () => {
        const blob = new Blob([bulkUUIDs.join("\n")], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "bulk-uuids.txt";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setHasDownloaded(true);
        setTimeout(() => setHasDownloaded(false), 2000);
    };

    

    

    const singleUUIDGenerate = async () => {
        try {
            const payload = {
                version: selectedVersion.value,
                count: 1
            }
            const response = await UUIDGenerateAPI(payload);
            setSingleUUID(response.data.uuids[0]);
        } catch (error) {
            console.error("Error converting case:", error);
        }
    }

    const MultipleUUIDGenerate = async () => {
        try {
            const payload = {
                version: bulkVersion.value,
                count: bulkCount
            }
            const response = await UUIDGenerateAPI(payload);
            setbulkUUIDS(response.data.uuids);
        } catch (error) {
            console.error("Error converting case:", error);
        }
    }


    return (
        <>
            <Col>
                <ToolHeader title="UUID Generator" description="Generate universally unique identifiers (UUIDs) in various versions. The tool supports version 4 (random), version 1 (time-based), and version 7 (time-ordered + random). Bulk generation allows creating up to 1000 UUIDs at once." toolFav={toolFav} />

                <Row className="uuid-container">
                    {/* LEFT PANEL */}
                    <div className="uuid-card active-card">
                        <div className="uuid-header">
                            <span>Single UUID Generator</span>
                        </div>

                        <div className="uuid-body">
                            <label>UUID Version</label>
                            <select
                                value={selectedVersion.value}
                                onChange={(e) =>
                                    setSelectedVersion(versions.find(a => a.value === e.target.value))
                                }
                            >
                                {versions.map((item) => (
                                    <option key={item.value} value={item.value}>{item.name}</option>
                                ))}
                            </select>

                            <p className="helper-text">
                                Randomly generated UUID (recommended for most use cases)
                            </p>

                            <button className="generate-btn" onClick={() => singleUUIDGenerate()}>
                                <GenerateIcon className="btn-icon" />
                                Generate
                            </button>

                            <label className="mt-20">Generated UUID</label>

                            <div className="uuid-output-row">
                                <input
                                    value={singleUUID}
                                    readOnly
                                />

                                <button
                                    className="copy-btn"
                                    onClick={() => handleCopy(singleUUID, "single")}
                                >
                                    <CopyIcon className="small-icon" />
                                    {hasSingleCopied ? "Copied!" : ""}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT PANEL */}
                    <div className="uuid-card">
                        <div className="uuid-header space-between">
                            <span>Bulk UUID Generator</span>

                            <div className="header-actions">
                                <button onClick={() => { handleDownload() }}>
                                    <DownloadIcon className="small-icon" />
                                    {hasDownloaded ? "Downloaded !!" : "Download"}
                                </button>

                                <button onClick={() => handleCopy(bulkUUIDs, "bulk")}>
                                    <CopyIcon className="small-icon" />
                                    {hasBulkCopied ? "Copied !!" : "Copy"}
                                </button>
                            </div>
                        </div>

                        <div className="uuid-body">
                            <label>UUID Version</label>
                            <select
                                value={bulkVersion.value}
                                onChange={(e) =>
                                    setBulkVersion(versions.find(a => a.value === e.target.value))
                                }
                            >
                                {versions.map((item) => (
                                    <option key={item.value} value={item.value}>{item.name}</option>
                                ))}
                            </select>
                            <label className="mt-20">
                                Number of UUIDs
                            </label>
                            <input
                                type="number"
                                min="1"
                                max="1000"
                                value={bulkCount}
                                onChange={(e) => {
                                    const value = e.target.value === "" ? "" : Math.min(1000, Math.max(1, Number(e.target.value)));
                                    setBulkCount(value);
                                }}
                            />
                            <p className="helper-text">
                                Generate up to 1000 UUIDs at once
                            </p>
                            <button className="generate-btn" onClick={() => MultipleUUIDGenerate()}>
                                <GenerateIcon className="btn-icon" />
                                Generate Bulk
                            </button>
                            <div className="bulk-output">
                                {bulkUUIDs.map((uuid, index) => (
                                    <div key={index}>{uuid}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Row>
            </Col >
        </>
    )
}

export default UUIDGenerator;
